import { render, staticRenderFns } from "./OrgProvince.vue?vue&type=template&id=1ed538ec&scoped=true&"
import script from "./OrgProvince.vue?vue&type=script&lang=js&"
export * from "./OrgProvince.vue?vue&type=script&lang=js&"
import style0 from "./OrgProvince.vue?vue&type=style&index=0&id=1ed538ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed538ec",
  null
  
)

export default component.exports